import dayjs from "dayjs";

import { useGlobal } from "@/migrated-widgets/table-map/contexts/GlobalState";
import { useAsync } from "@/migrated-widgets/table-map/hooks/useAsync";
import { ActiveDealerListService } from "@/migrated-widgets/table-map/services";

export const useDealerMarkers = () => {
    const { params } = useGlobal();

    const { response: dealerMarkers = [], loading: loadingDealers = true } = useAsync(async () => {
        const res = await ActiveDealerListService.getDealerData({
            Date: dayjs(params.endDate ?? new Date()).format("YYYY-MM-DD"),
            Cliid: params.dealerRefId,
            token: params.token,
        });

        const dataCollection = res.dealerMarkers;

        return dataCollection;
    }, [params]);

    return {
        dealerMarkers,
        loadingDealers,
    };
};
